import { memo } from 'react';
import TourPopoverBase from './TourPopoverBase';
import { useTourPopoverFade } from './useTourPopoverFade';
import type { BaseTourStop, TourContextInterface } from './tourContextBase';

export function createTourPopover<
  TStop extends BaseTourStop,
  T extends HTMLElement,
>(useTourHook: () => TourContextInterface<TStop, T>) {
  const TourPopoverInner = () => {
    const context = useTourHook();
    const { open } = useTourPopoverFade(context?.currentStop?.id);

    if (!context) {
      return null;
    }

    const {
      isFirstStop,
      isLastStop,
      currentStopNumber,
      totalStops,
      hasCompletedTour,
      currentStop,
      ref,
      goToNextStop,
      goToPreviousStop,
      skipTour,
    } = context;

    if (hasCompletedTour || !currentStop || !open) {
      return null;
    }

    return (
      <TourPopoverBase
        key={currentStop.id}
        open={open}
        anchorEl={currentStop.position ? null : (ref?.current ?? null)}
        currentStop={currentStop}
        isFirstStop={isFirstStop}
        isLastStop={isLastStop}
        currentStopNumber={currentStopNumber}
        totalStops={totalStops}
        goToNextStop={goToNextStop}
        goToPreviousStop={goToPreviousStop}
        skipTour={skipTour}
      />
    );
  };

  return memo(TourPopoverInner);
}
